module.exports = __webpack_public_path__ + "../resources/img/img_ef_layer3_no-inverter-no-battery.42b626e1.svg";